import { growDivClass, labelClass, smallTextBelowClass, wrapperClass } from "./input-text.styles";
import { InputTextSkeletonProps } from "./input-text.types";
import { getLabelColor } from "./input-text.util";
import { Skeleton } from "../skeleton";

export const InputTextSkeleton = ({ label, smallTextBelow }: InputTextSkeletonProps) => {
	const labelColor = getLabelColor(false, false, false);

	return (
		<div className={wrapperClass}>
			{label && <div className={labelClass({})}>{label}</div>}
			<div className={growDivClass}>
				<Skeleton width="100%" height="2.5rem" />
			</div>
			{smallTextBelow && (
				<div className={smallTextBelowClass({ ...labelColor })}>{smallTextBelow}</div>
			)}
		</div>
	);
};
